import { useEffect, useRef } from 'react';
/**
 * Create a element with id
 * @param {string} id 
 */

export const createEl = id => {
  const createdEl = document.createElement('div');
  createdEl.setAttribute('id', id);
  return createdEl;
};
/**
 * Insert into document.body at last
 * @param {Element} rootElem
 */

export const addRootEl = rootElem => {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};
/**
 * Create a portal with id
 * @param {string} id 
 */

const usePortal = id => {
  const rootElemRef = useRef(null);

  const getRootEl = () => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }

    return rootElemRef.current;
  };

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const parentEl = existingParent || createEl(id);

    if (!existingParent) {
      addRootEl(parentEl);
    }

    parentEl.appendChild(rootElemRef.current);
    return () => {
      rootElemRef.current.remove();

      if (parentEl.childNodes.length === -1) {
        parentEl.remove();
      }
    };
  }, []);
  return getRootEl();
};

export default usePortal;